import { Link } from 'react-router-dom';
import { ArrowRight, MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EngravedBackground } from '@/components/common/EngravedBackground';

/**
 * Call-to-action section for contact
 */
export function ContactCTA() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-card to-background">
      <div className="container-custom">
        <div className="relative overflow-hidden rounded-2xl border border-border bg-card p-8 md:p-12 lg:p-16">
          {/* Engraved Logo Background */}
          <EngravedBackground
            size="md"
            position="right"
            opacity={0.03}
          />

          {/* Decorative gradient */}
          <div className="absolute -top-24 -right-24 h-48 w-48 rounded-full bg-primary/20 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 h-48 w-48 rounded-full bg-primary/10 blur-3xl" />

          <div className="relative z-10 flex flex-col items-center text-center">
            {/* Icon */}
            <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 text-primary">
              <MessageSquare className="h-8 w-8" aria-hidden="true" />
            </div>

            {/* Category label */}
            <span className="category-label">Get in Touch</span>

            {/* Heading */}
            <h2 className="max-w-2xl text-3xl font-bold md:text-4xl">
              Ready to discuss your project?
            </h2>

            {/* Description */}
            <p className="mt-4 max-w-xl text-muted-foreground">
              Whether you need gardening, cleaning, or taxidermy services, I'm here to help.
              Get in touch for a free consultation and quote.
            </p>

            {/* CTA */}
            <Button asChild size="lg" className="mt-8 gap-2">
              <Link to="/contact">
                Contact Me
                <ArrowRight className="h-4 w-4" aria-hidden="true" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
